import { useContext, useEffect, useMemo, useState } from 'react';
import { showCustomDialog } from '../../scripts/learnosityScripts.js';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import CustomDialog from '../ui/feedback/CustomDialog.js';
import { useTranslation } from 'react-i18next';

const SubmitErrorDialog = ({ open, setOpen }) => {
  const { learnosityItemApp, submitInProgress, setSubmitInProgress } =
    useContext(AssessmentContext);
  const { t } = useTranslation();

  const SUBMIT_IN_PROGRESS_DIALOG_DETAILS = useMemo(() => {
    return {
      title: t('components.submitErrorDialog.submitInProgress'),
      showWaiting: true,
    };
  }, [t]);

  const SUBMIT_ERROR_DIALOG_DETAILS = useMemo(() => {
    return {
      title: t('components.submitErrorDialog.errorTitle'),
      message: t('components.submitErrorDialog.errorMessage'),
      showWaiting: false,
    };
  }, [t]);

  const DIALOG_ACTIONS = useMemo(
    () => [
      {
        label: t('components.submitErrorDialog.tryAgain'),
        handle: () => {
          learnosityItemApp?.submit({
            //Success is handled in TestEventHandler
            // Allows you to immediately handle a save error event
            error: (event) => {
              setSubmitInProgress(false);
              setDialogDetails({
                ...SUBMIT_ERROR_DIALOG_DETAILS,
                actions: DIALOG_ACTIONS,
              });
            },
            progress: () => {
              setSubmitInProgress(true);
              setDialogDetails(SUBMIT_IN_PROGRESS_DIALOG_DETAILS);
            },
            show_submit_ui: true, //This is to make sure outro items are displayed
            show_submit_confirmation: false //required for silient submission
          });
        },
      },
    ],
    [
      learnosityItemApp,
      SUBMIT_ERROR_DIALOG_DETAILS,
      setSubmitInProgress,
      SUBMIT_IN_PROGRESS_DIALOG_DETAILS,
      t,
    ],
  );

  const [dialogDetails, setDialogDetails] = useState(
    SUBMIT_IN_PROGRESS_DIALOG_DETAILS,
  );

  useEffect(() => {
    if (open) {
      showCustomDialog(learnosityItemApp, {
        header: dialogDetails.title,
        body: dialogDetails.message,
      });
    }
  }, [open, learnosityItemApp, dialogDetails]);

  useEffect(() => {
    if (submitInProgress) {
      setDialogDetails(SUBMIT_IN_PROGRESS_DIALOG_DETAILS);
    } else {
      setDialogDetails({
        ...SUBMIT_ERROR_DIALOG_DETAILS,
        actions: DIALOG_ACTIONS,
      });
    }
  }, [
    submitInProgress,
    SUBMIT_ERROR_DIALOG_DETAILS,
    SUBMIT_IN_PROGRESS_DIALOG_DETAILS,
    DIALOG_ACTIONS,
  ]);

  return (
    <>
      <CustomDialog open={open} dialogProps={dialogDetails} />
    </>
  );
};

export default SubmitErrorDialog;
